<template>
    <v-btn outlined x-small color="grey" @click="reload">Versão: 1.7.2</v-btn>
</template>

<script>
export default {
    methods: {
        reload() {
            document.location.reload(true);
        },
    },
};
</script>